import { Helpers } from "../helpers";
import $ from "jquery";
export const renderDate = {
    init: () => {
        renderDate.enableGlobal();
        const attr = "convert-date";
        let $dateEls = $("[data-${attr}]");
        if ($dateEls.length) {
            $dateEls.each(function () {
                const dtStr = $(this).data(`${attr}`);
                $(this).html(Helpers.swapDateMonth(dtStr));
            });
        }
    },
    enableGlobal: () => {
        if (!window["renderDate"]) {
            window["renderDate"] = renderDate;
        }
    },
};
